import moment from "moment";
import { AuditLog } from "@/models/logs/AuditLog";
import { FacilitySettingsModel } from '@/models/FacilitySettings';
import { AuditLogsTier1 } from '@/enums/AuditLogs';

export default {
  name: "AuditLogs",
  filters: {
    capitalize(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatedData(data) {
      if (!data) return "";
      const sensitiveData: string[] = [
        "setPasswordToken",
        "unsubscribeFromEmailsToken"
      ]

      const result = Object.entries(data)
        .flatMap(([key, value]) => {
          if (!value || typeof value !== "object") return [];

          let { before, after } = value as { before?: any; after?: any };

          if (before?.hasOwnProperty("seconds")) {
            before = moment(before.seconds * 1000).format("YYYY-MM-DD HH:mm:ss");
          }
          if (after?.hasOwnProperty("seconds")) {
            after = moment(after.seconds * 1000).format("YYYY-MM-DD HH:mm:ss");
          }

          if (before == null && after == null) return [];

          const fieldKey = key.split(".").pop()?.replace(/\[[^\]]*\]/g, "");

          const label = fieldKey
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .replace(/Iso/gi, "")
            .replace(/\s+/g, " ")
            .trim()
            .replace(/^./, str => str.toUpperCase());

          const entries: { label: string; value: string }[] = [];

          if (after != null) {
            entries.push({
              label,
              value: sensitiveData.includes(key) ? "********" : after,
            });
          }

          if (before != null) {
            entries.push({
              label: `${label} (old)`,
              value: sensitiveData.includes(key) ? "********" : before,
            });
          }

          return entries;
        });

      return result.map(entry => `${entry.label}: ${JSON.stringify(entry.value)}`).join("\n");
    }
  },
  data() {
    return {
      loading: false,
      search: "",
      types: [],
      startDatePicker: {
        menu: false,
        date: moment().subtract("month", 1).format('YYYY-MM-DD')
      },
      endDatePicker: {
        menu: false,
        date: moment().format('YYYY-MM-DD')
      },
      headers: [
        {
          text: this.$t('GeneralTranslations.Date'),
          align: "start",
          value: "timestamp",
          width: 200,
        },
        {
          text: this.$t('AuditLogs.Author'),
          align: "start",
          value: "initiatorName",
          width: 200,
        },
        {
          text: this.$t('AuditLogs.ChangeType'),
          align: "start",
          value: "changeType",
          width: 130,
        },
        {
          text: this.$t('AuditLogs.TypeOfRecordChanged'),
          align: "start",
          value: "typesOfRecordChanged",
          width: 320,
        },
        {
          text: this.$t('AuditLogs.ChangesMade'),
          align: "start",
          value: "changedFields",
          width: 300,
        },
      ]
    }
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    auditLogs(): AuditLog[] {
      return this.$store.state.auditLogsModule.auditLogs.map(x=>this.decorateAuditLogs(x))
    },
    auditLogsFiltered(): AuditLog[] {
      const query = this.search.trim().toLowerCase();
      const hasSearch = query.length > 0;
      const hasTypesFilter = this.types.length > 0;

      const filtered = this.auditLogs.filter((item: AuditLog) => {
        const matchesName = !hasSearch || item.initiatorName.toLowerCase().includes(query);
        const hasAllowedType = !hasTypesFilter || item.types.some((type: string) => this.types.includes(type));
        return matchesName && hasAllowedType;
      });

      return [...filtered].sort((a, b) =>
        Date.parse(b.timestamp) - Date.parse(a.timestamp)
      );
    },
    recordsTypes() {
      return Object.values(AuditLogsTier1)
    },
    emailTemplates(){
      return this.$store.state.facilityModule.currentEmailTemplates
    }
  },
  async created() {
    await this.$store.dispatch("getEmailTemplates");
    await this.getAuditLogs();
  },
  methods: {
    async getAuditLogs() {
      this.loading = true;
      await this.$store.dispatch("getAuditLogs", {
        startDate: moment(this.startDatePicker.date).startOf('day').toDate(),
        endDate: moment(this.endDatePicker.date).endOf('day').toDate(),
      });
      this.loading = false;
    },
    decorateAuditLogs(auditLog){
      if(auditLog?.collection === 'emailTemplates' && auditLog?.changedFields){
        let typeName = 'Unknown'
        if(auditLog.data.typeId){
          typeName = this.emailTemplates?.find(x=>x.id === auditLog.data.typeId) || 'Unknown'
        } else{
          typeName = auditLog.data.type
        }
        auditLog.changedFields.type = {
          after: typeName
        }
      }

      return auditLog
    }
  }
}